import React, { useState, useEffect } from 'react';
import {
  Typography,
  Container,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  IconButton,
  Tooltip,
  Link,
  Chip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LandingPageLayoutDesktop from '../../layout/LandingPageLayoutDesktop';
import { Person, PersonAdd, MenuBook, Check } from '@mui/icons-material';
import tipoContrattoApi from '../../api/tipocontrattoApi';
import logoImg from '../../assets/logo.png';

export default function DeskStudioLandingPageDesktopRev() {
  const navigate = useNavigate();
  const [tipiContratto, setTipiContratto] = useState([]);

  const handleRegisterFromPlan = (profile, tipoContrattoId) => {
    const params = new URLSearchParams({
      profile,
      tipoContrattoId: tipoContrattoId ?? ''
    });
    navigate(`/register?${params.toString()}`);
  };

  useEffect(() => {
    async function fetchTipi() {
      try {
        const res = await tipoContrattoApi.getAllPublic();
        setTipiContratto(res.data.filter(t => t.attivo && t.tipo !== 'BASIC'));
      } catch (e) {
        console.error(e);
      }
    }
    fetchTipi();
  }, []);

  if (!tipiContratto) return null;

  return (
    <LandingPageLayoutDesktop>
      {/* HERO */}
      <Box
        id="hero"
        sx={{
          py: 16,
          textAlign: 'center',
          background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
        }}
      >
        <Container>
          <img src={logoImg} alt="DeskStudio" style={{ maxWidth: '120px', marginBottom: 24 }} />

          <Typography variant="h2" sx={{ fontWeight: 800, mb: 2 }}>
            DeskStudio
          </Typography>

          <Typography variant="h5" sx={{ mb: 3, color: '#555' }}>
            Il gestionale delle scadenze fiscali moderno, semplice e automatizzato.
          </Typography>

          <Typography variant="h6" sx={{ mb: 4, color: '#777' }}>
            Hai difficoltà a tenere sotto controllo scadenze fiscali, pagamenti e documenti?
          </Typography>

            <Typography variant="h6" sx={{ mb: 4, color: '#777' }}>
              DeskStudio automatizza tutto: meno errori, meno tempo perso, più controllo.
            </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button variant="outlined" size="large" onClick={() => navigate('/register')}>
              Prova gratis
            </Button>

            <Button variant="text" onClick={() => window.open(`${process.env.PUBLIC_URL}/manualeUtente.pdf`, '_blank')}>
              Manuale
            </Button>
          </Stack>
                  <Stack direction="row" spacing={2} justifyContent="center">
                    <Button variant="text" onClick={() => navigate('/privacy')} >
                      Privacy
                    </Button>
                    <Button variant="text"  onClick={() => navigate('/terms')}>
                      Termini e Condizioni
                    </Button>
                     <Button variant="text" onClick={() => navigate('/cookie')}>
                         Cookie Policy
                    </Button>
                  </Stack>
                   {/*<Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} justifyContent="center" sx={{ mt: 2 }}>
                          <Typography variant="h5" sx={{ mb: 3, color: '#555' }}>
                            Aiutaci a sviluppare il progetto. Iscriviti alla mailing list.
                            Chi si iscrive avrà vantaggi e sconti sulla piattaforma DeskStudio
                          </Typography>
                   </Stack>
                   <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} justifyContent="center" sx={{ mt: 2 }}>
                          <Typography variant="h5" sx={{ mb: 4, textAlign: 'center', color: '#2742F5' }}>
                            <Button variant="text"  onClick={() => navigate('/sitopubblico/crowdfunding')}>
                              Scopri il progetto
                            </Button>
                         </Typography>
                  </Stack>*/}
        </Container>
      </Box>

      {/* PROBLEMA */}
      <Container id="problema" sx={{ py: 12 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
          Le scadenze non dovrebbero essere un problema
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#666' }}>
          Tra documenti sparsi, controlli manuali e scadenze dimenticate, la gestione fiscale diventa un rischio.
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#666' }}>
          <Button variant="outlined" onClick={() => document.getElementById('contatti').scrollIntoView()}> Richiedi informazioni</Button>
         </Typography>
      </Container>

      {/* SOLUZIONI */}
      <Box id="soluzioni" sx={{ py: 12, bgcolor: '#f8fafc' }}>
        <Container>
          <Typography variant="h4" sx={{ mb: 6, textAlign: 'center', fontWeight: 700 }}>
            Tutto quello che ti serve
          </Typography>

          <Grid container spacing={4}>
            {[
            { title: 'Documenti centralizzati', desc: 'Archivia e consulta tutte le fatture e i documenti in un unico spazio sicuro.' },
            { title: 'Scadenze automatiche', desc: 'Il sistema genera automaticamente le scadenze evitando dimenticanze.' },
             { title: 'Accesso clienti', desc: 'Condividi documenti e scadenze con i tuoi clienti in modo semplice.' },
             { title: 'Pagamenti tracciati', desc: 'Controlla lo stato dei pagamenti in tempo reale.' },
             { title: 'Notifiche intelligenti', desc: 'Ricevi alert automatici prima delle scadenze importanti.' },
             { title: 'Sicurezza avanzata', desc: 'I tuoi dati sono protetti con standard elevati.' } ].map((f, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <Card sx={{ p: 3, borderRadius: 4 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Check color="primary" />
                    <Typography fontWeight={600}>{f.title}</Typography>
                  </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography fontWeight={400}>{f.desc}</Typography>
                    </Stack>
                </Card>
              </Grid>
            ))}
          </Grid>
                      <Typography variant="h6" sx={{ textAlign: 'center', color: '#666' }}>
                        <Button variant="outlined" onClick={() => document.getElementById('contatti').scrollIntoView()}> Parla con noi</Button>
                       </Typography>
        </Container>
      </Box>

      {/* TESTIMONIANZE */}
      <Container id="testimonianze" sx={{ py: 12 }}>
        <Typography variant="h4" sx={{ mb: 6, textAlign: 'center', fontWeight: 700 }}>
          Cosa dicono i clienti
        </Typography>

        <Grid container spacing={4}>
          {[
            '“Risparmio ore ogni settimana grazie alla automazione.”',
            '“Finalmente ho il controllo completo delle scadenze”'
          ].map((t, i) => (
            <Grid item xs={12} md={6} key={i}>
              <Card sx={{ p: 4, borderRadius: 4 }}>
                <Typography>{t}</Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* PREZZI */}
      <Box id="prezzi" sx={{ py: 12, bgcolor: '#f8fafc' }}>
        <Container>
          <Typography variant="h6" sx={{ mb: 6, textAlign: 'center', fontWeight: 300 }}>
          Scegli il piano più adatto a te e semplifica la gestione fiscale.
          </Typography>

          <Grid container spacing={4}>
            {[
              { plan: 'Base', price: '129€/anno', desc: '1 contribuente', profile: 'CONTRIBUENTE', tipoContrattoId: null },
              { plan: 'Studio 10', price: '349€/anno', desc: 'Fino a 10 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO10')?.id },
              { plan: 'Studio 20', price: '549€/anno', desc: 'Fino a 20 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO20')?.id },
              { plan: 'Studio 50', price: '899€/anno', desc: 'Fino a 50 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO50')?.id },
              { plan: 'Studio 150', price: '1799€/anno', desc: 'Fino a 150 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO150')?.id },
              { plan: 'Studio Plus', price: '2799€/anno', desc: 'Illimitati', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo == 'FULL')?.id },
            ].map((p, i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <Card sx={{ p: 4, borderRadius: 4, textAlign: 'center' }}>
                  <Typography variant="h6">{p.plan} ({p.profile==='STUDIO'?'Commercialista':'Partita IVA'})</Typography>
                  <Typography variant="h4" sx={{ my: 2, fontWeight: 700 }}>
                    {p.price}
                  </Typography>
                  <Typography sx={{ mb: 2, color: '#666' }}>{p.desc}</Typography>

                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => handleRegisterFromPlan(p.profile, p.tipoContrattoId)}
                  >
                    Scegli
                  </Button>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CONTATTI */}
      <Container id="contatti" sx={{ py: 10 }}>
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          Contattaci
        </Typography>

        <Typography sx={{ textAlign: 'center', mt: 2 }}>
          <Link href="mailto:info@deskstudio.it">
            info@deskstudio.it
          </Link>
        </Typography>
      </Container>

      {/* FOOTER */}
      <Box sx={{ bgcolor: '#111', color: '#fff', py: 3, textAlign: 'center' }}>
        <Typography>DeskStudio © 2026</Typography>
      </Box>
    </LandingPageLayoutDesktop>
  );
}